import {type FunctionalComponent, h} from '@stencil/core';
import type { SearchApiDocumentMySE } from '../../../../../../api/model/response/documents/private/MySEDocument';
import { UiaasSearchLabelList } from '../../../../result-cards/subcomponents/uiaas-search-label-list';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IDashboardQuoteItemProperties {
    doc: SearchApiDocumentMySE;
    labelProvider: labelProviderInterface;
}

export const DashboardQuoteItemLabels: FunctionalComponent<IDashboardQuoteItemProperties> = (props) => {
    const { doc, labelProvider } = props;

    return (
      <span><UiaasSearchLabelList
        list={[
          {
            label: labelProvider('result.seamless.pqNumber', 'PQ Number'),
            value: doc?.pqNumber,
          },
          {
            value: labelProvider('result.seamless.' + doc.source, doc.source),
            customValueClass: 'private__category',
          }
        ]}
      />
      <UiaasSearchLabelList
        list={[
          {
            label: labelProvider('result.seamless.id', 'ID'),
            value: doc?._id
          },
          {
            label: labelProvider('result.seamless.validateOn', 'Valid on'),
            value: doc?.validationDate
          }
        ]}
      />
      </span>);
};
